var map = {
	"./Cerebro.svg": "8a2c",
	"./Frustracion.svg": "c65e",
	"./Lady_completed.svg": "01ff",
	"./Lady_lock.svg": "6471",
	"./Mano.svg": "73e4",
	"./Monito.svg": "21cc",
	"./Tigre_completed.svg": "d326",
	"./Tigre_lock.svg": "77ac",
	"./abacas.svg": "2a5f",
	"./abacus.svg": "f334",
	"./abacusmachine.svg": "db2b",
	"./acumula.svg": "7be2",
	"./avlogo.svg": "7f7c",
	"./back.svg": "c9a6",
	"./big_cup.svg": "9f2d",
	"./big_flug_active.svg": "5214",
	"./big_flug_deactive.svg": "31de",
	"./bigcard.svg": "414b",
	"./brain.svg": "ba3b",
	"./card.svg": "3522",
	"./card_open.svg": "81af",
	"./check_circle.svg": "fe4c",
	"./checkmark.svg": "f2fa",
	"./closeabacus.svg": "9db1",
	"./coin.svg": "d023",
	"./directions_run.svg": "81cd",
	"./equal.svg": "e822",
	"./fastmind.svg": "1ace",
	"./goal_flug.svg": "6837",
	"./medium_cup.svg": "cbc3",
	"./moneypic.svg": "e483",
	"./openabacus.svg": "7909",
	"./platform.svg": "0f6d",
	"./remove_circle.svg": "7c86",
	"./small_cup.svg": "f77f",
	"./small_flug_active.svg": "b12b",
	"./small_flug_deactive.svg": "01ee",
	"./support-white.svg": "6f4c",
	"./support.svg": "85fe",
	"./videoarrow.svg": "bccc",
	"./videocard.svg": "2634",
	"./videomissarrow.svg": "c5a7",
	"./youtube.svg": "694f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";